import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCourseExclusion } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useCreateCourseExclusion = (onSuccess) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ courseConfigId, payload }) =>
      createCourseExclusion(courseConfigId, payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: [moodleQueryKeys.courseExclusions],
      });
      onSuccess?.(...args);
    },
  });

  return { mutate, isPending };
};
